// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607271148/js/" + chunkId + "." + {"44":"07d9ce14","225":"386df0fd","481":"a0c77693","486":"37204d51","770":"4a0b938d"}[chunkId] + ".0.5697103030316456.chunk.js";
};